import type { UserManagerSettings } from "oidc-client-ts";

export const oauth2Enabled = process.env.REACT_APP_OAUTH2_ENABLED === "true";

export const oauth2Config: UserManagerSettings = {
  authority: process.env.REACT_APP_OAUTH2_AUTHORITY ?? "",
  client_id: process.env.REACT_APP_OAUTH2_CLIENT_ID ?? "cnb-web-app",
  redirect_uri:
    process.env.REACT_APP_OAUTH2_REDIRECT_URI ??
    `${window.location.origin}/callback`,
  post_logout_redirect_uri:
    process.env.REACT_APP_OAUTH2_POST_LOGOUT_REDIRECT_URI ??
    window.location.origin,
  scope: "openid user",
  response_type: "code",
  automaticSilentRenew: true,
  loadUserInfo: false,
};

export const onSigninCallback = (): void => {
  window.history.replaceState({}, document.title, window.location.pathname);
};
